'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_PROP = exports.UPDATE_TITLE = exports.replaceDb = exports.REPLACE_DB = undefined;
exports.updateTitle = updateTitle;
exports.updateProp = updateProp;

var _capeRedux = require('cape-redux');

var REPLACE_DB = exports.REPLACE_DB = 'db/REPLACE_DB';
var replaceDb = exports.replaceDb = (0, _capeRedux.createAction)(REPLACE_DB);

var UPDATE_TITLE = exports.UPDATE_TITLE = 'db/UPDATE_TITLE';
function updateTitle(value) {
  return {
    type: UPDATE_TITLE,
    payload: value
  };
}

var UPDATE_PROP = exports.UPDATE_PROP = 'db/UPDATE_PROP';
function updateProp(path, value) {
  return { type: UPDATE_PROP, payload: { path: path, value: value } };
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-reducer/lib/db/actions.js
// module id = 367
// module chunks = 0